import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setChatVisibility } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { RootState } from '../../../../app';
import CollaboratorChat from './CollaboratorChat';
import CollaboratorChatHeader from './CollaboratorChatHeader';
import { CollaboratorContainer } from './CollaboratorChatbox.styles';

const CollaboratorChatbox = () => {
  const dispatch = useDispatch();
  const isChatBoxVisible = useSelector(
    (state: RootState) =>
      state.eventPane.chatVisibility.isCollaboratorChatVisible,
  );
  const setIsChatBoxVisible = useCallback(
    (isVisible: boolean) => {
      dispatch(
        setChatVisibility({
          chatType: 'isCollaboratorChatVisible',
          isVisible,
        }),
      );
    },
    [dispatch],
  );

  return (
    <CollaboratorContainer
      data-name="conversations-container"
      flex={isChatBoxVisible ? '1 1 auto' : '0'}
      height="100%"
    >
      <CollaboratorChatHeader
        isChatBoxVisible={isChatBoxVisible}
        setIsChatBoxVisible={setIsChatBoxVisible}
      />
      <CollaboratorChat isChatBoxVisible={isChatBoxVisible} />
    </CollaboratorContainer>
  );
};

export default CollaboratorChatbox;
